/**
 * Vehicle status values
 */
export enum VehicleStatusEnum {
	/**
	 * Vehicle is in the park
	 */
	IN_PARK = 'in_park',
	/**
	 * Vehicle is on hold
	 */
	HARD_HOLD = 'hard_hold',
	/**
	 * Vehicle is out of service
	 */
	OUT_OF_SERVICE = 'out_of_service',
	/**
	 * Vehicle is reserved
	 */
	RESERVED = 'reserved',
	/**
	 * Vehicle is rented
	 */
	RENTED = 'rented',
	/**
	 * Vehicle is reserved for maintenance
	 */
	RESERVED_MAINTENANCE = 'reserved_maintenance',
	/**
	 * Vehicle is in maintenance
	 */
	IN_MAINTENANCE = 'in_maintenance',
	/**
	 * Vehicle has been sold and is no longer in operation
	 */
	SOLD = 'sold',
}
